import { ScrollView } from '@ipfabric/ui-components/ScrollView/ScrollView';
import { useRef } from 'react';
import type { FC, ReactNode, RefObject } from 'react';
import type Scrollbars from 'react-custom-scrollbars-2';
import type { positionValues } from 'react-custom-scrollbars-2';
import {
  type ArrowKeyNavigationMouseEnter,
  useArrowKeyNavigation,
} from 'utils/keyboard/useArrowKeyNavigation';

interface Props {
  wrapperRef: RefObject<HTMLElement>;
  onScrollBottom?: () => void;
  render: (f: ArrowKeyNavigationMouseEnter) => ReactNode;
}

export const SelectMenu: FC<Props> = (props) => {
  const scrollViewRef = useRef<Scrollbars>(null);
  const { handleOptionMouseEnter } = useArrowKeyNavigation({
    scrollViewRef,
    wrapperRef: props.wrapperRef,
  });

  return (
    <div
      className='select__menu'
      // biome-ignore lint/a11y/useSemanticElements: This div is used as a custom select menu container but is not a semantic list element
      role='list'
    >
      <ScrollView
        autoHeight
        autoHeightMax='13em'
        onUpdate={({
          scrollTop,
          scrollHeight,
          clientHeight,
        }: positionValues) => {
          if (scrollTop >= scrollHeight - clientHeight) {
            props.onScrollBottom?.();
          }
        }}
        ref={scrollViewRef}
      >
        {props.render(handleOptionMouseEnter)}
      </ScrollView>
    </div>
  );
};
